import { useState, useEffect } from 'react';
import { Box, Grid, Paper, Typography, Stack, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';

export default function Home() {
  const [time, setTime] = useState(new Date());
  const theme = useTheme();

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTimeUnit = (unit) => unit.toString().padStart(2, '0');

  const hours = formatTimeUnit(time.getHours());
  const minutes = formatTimeUnit(time.getMinutes());
  const seconds = formatTimeUnit(time.getSeconds());
  const day = time.toLocaleDateString('en-US', { weekday: 'long' });
  const date = time.toLocaleDateString('en-US', { dateStyle: 'full' });

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Grid container spacing={4}>
        {/* Left Side - Clock */}
        <Grid container flexGrow={1} md={8}>
          <div className="mockup-browser border border-base-300 w-full">
            <div className="mockup-browser-toolbar">
              <div className="input border border-base-300">
                {date}
              </div>
            </div>
            <div className="flex flex-col items-center justify-center p-4 h-full">
                <Typography variant="h3" color="text.primary" className="mb-12" sx={{ fontWeight: 'bold' }}>
                  {day}
                </Typography>
                <div className="grid grid-flow-col gap-8 text-center w-full">
                  <div className="flex flex-col p-6 bg-neutral rounded-box text-neutral-content flex-1">
                    <span className="countdown font-mono text-7xl lg:text-8xl xl:text-9xl">
                      <span style={{ "--value": parseInt(hours) }}></span>
                    </span>
                    <span className="text-xl mt-4">hours</span>
                  </div> 
                  <div className="flex flex-col p-6 bg-neutral rounded-box text-neutral-content flex-1">
                    <span className="countdown font-mono text-7xl lg:text-8xl xl:text-9xl">
                      <span style={{ "--value": parseInt(minutes) }}></span>
                    </span>
                    <span className="text-xl mt-4">minutes</span>
                  </div> 
                  <div className="flex flex-col p-6 bg-neutral rounded-box text-neutral-content flex-1">
                    <span className="countdown font-mono text-7xl lg:text-8xl xl:text-9xl">
                      <span style={{ "--value": parseInt(seconds) }}></span>
                    </span>
                    <span className="text-xl mt-4">seconds</span>
                  </div>
                </div>
              </div>
          </div>
        </Grid>

        {/* Right Side - Services & Info */}
        <Grid container md={4}>
          <Stack spacing={3} sx={{ width: '100%' }}>
            <Paper elevation={3} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>Our Services</Typography>
              <Grid container spacing={2}>
                <Grid container xs={6}>
                  <Link to="/timer" style={{ textDecoration: 'none', width: '100%' }}>
                    <Paper elevation={2} sx={{ 
                      p: 2, 
                      textAlign: 'center',
                      '&:hover': { bgcolor: 'action.hover' },
                      width: '100%'
                    }}>
                      <Typography>Timer</Typography>
                    </Paper>
                  </Link>
                </Grid>
                <Grid container xs={6}>
                  <Link to="/stopwatch" style={{ textDecoration: 'none', width: '100%' }}>
                    <Paper elevation={2} sx={{ 
                      p: 2, 
                      textAlign: 'center',
                      '&:hover': { bgcolor: 'action.hover' },
                      width: '100%'
                    }}>
                      <Typography>Stopwatch</Typography>
                    </Paper>
                  </Link>
                </Grid>
              </Grid>
            </Paper>

            <Paper elevation={3} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>Games & Challenges</Typography>
              <Link to="/pi-challenge" style={{ textDecoration: 'none' }}>
                <Paper elevation={2} sx={{ 
                  p: 2, 
                  textAlign: 'center',
                  '&:hover': { bgcolor: 'action.hover' }
                }}>
                  <Typography>Pi Challenge</Typography>
                </Paper>
              </Link>
            </Paper>

            <Paper elevation={3} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>Latest Blog Posts</Typography>
              {blogPosts.slice(0, 3).map(post => (
                <Link key={post.id} to={`/blog/${post.slug}`} style={{ textDecoration: 'none' }}>
                  <Paper elevation={1} sx={{ 
                    p: 2, 
                    mb: 1,
                    '&:hover': { bgcolor: 'action.hover' }
                  }}>
                    <Typography variant="subtitle2">{post.title}</Typography>
                  </Paper>
                </Link>
              ))}
            </Paper>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}